<template>
  <div class="HomespaceDock">
    <div class="HomespaceDock__main">
      <div class="shrink-0">
        <button class="HomespaceDock__button flex justify-center items-center w-12 h-12 no-scrollbar" id="explorer-button" title="Widgets Explorer">
          <svg
            aria-hidden="true"
            class="sfa text-xl transition hover:scale-110 svelte-1tu5i4y"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path
              fill="#888"
              d="M80 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm0 256h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48zM288 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V80zm96 192c13.3 0 24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H408v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V408H296c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V296c0-13.3 10.7-24 24-24z"
            ></path>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.HomespaceDock {
  position: fixed;
  right: 50%;
  width: -moz-max-content;
  width: max-content;
  transform: translate(50%);
  z-index: 9999;
  bottom: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transform-origin: bottom;
  box-sizing: border-box;
}
.HomespaceDock__main {
  transition: all 0.2s ease-in-out;
  box-shadow: 0 0 10px 1px #0000001a;
  background-color: var(--glass-bg);
  color: var(--text);
  -webkit-backdrop-filter: blur(var(--blur));
  backdrop-filter: blur(var(--blur));
  border: 1px solid var(--border-color-lighter);
  transition: border-color 0.3s ease-in-out;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  border-radius: 9999px;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  max-width: 24rem;
  min-width: 3rem;
  height: 100%;
  display: flex;
  position: relative;
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shrink-0 {
  flex-shrink: 0;
}
.HomespaceDock__button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3rem;
  height: 3rem;
}
.sfa.svelte-1tu5i4y {
    width: 1em;
    height: 1em;
    overflow: visible;
    display: inline-block;
}

.transition {
    transition: all .3s ease-in-out;
}
.transition {
    transition-property: color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;
    transition-property: color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;
    transition-property: color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;
    transition-timing-function: cubic-bezier(.4,0,.2,1);
    transition-duration: .15s;
}
.text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
}
.svelte-1tu5i4y:hover {
    --tw-scale-x: 1.1;
    --tw-scale-y: 1.1;
    transform: translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
</style>
